import { AlertTriangle, X } from "lucide-react";
import { Link } from "wouter";
import { useState } from "react";
import { trpc } from "@/lib/trpc";
import { Button } from "@/components/ui/button";

/**
 * Banner component that displays a warning when seed/demo data is present in the database.
 * Shows a link to settings where users can delete the seed data.
 */
export function SeedDataBanner() {
  const [dismissed, setDismissed] = useState(false);
  const { data, isLoading } = trpc.seedData.check.useQuery(undefined, {
    // Only check once on mount, don't refetch constantly
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });

  // Don't show if loading, no seed data, or dismissed
  if (isLoading || !data?.hasSeedData || dismissed) {
    return null;
  }

  const totalRecords = 
    data.counts.instructors + 
    data.counts.courses + 
    data.counts.bookings + 
    data.counts.sessions + 
    data.counts.attendance;

  return (
    <div className="bg-amber-500/90 text-amber-950 px-4 py-2 relative z-50">
      <div className="container flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-5 w-5 flex-shrink-0" />
          <p className="text-sm font-medium">
            <span className="font-semibold">Demo-Daten aktiv:</span>{" "}
            Diese Instanz enthält {totalRecords.toLocaleString("de-DE")} Beispieldatensätze.{" "}
            <Link 
              href="/admin/settings" 
              className="underline underline-offset-2 hover:no-underline font-semibold"
            >
              In den Einstellungen entfernen →
            </Link>
          </p>
        </div>
        <Button
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0 hover:bg-amber-600/20 text-amber-950"
          onClick={() => setDismissed(true)}
          aria-label="Banner schließen"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
